import React from 'react';
import styled from 'styled-components';
import {FormattedMessage} from 'react-intl';
import {
    FORM_FIELD_FULLTEXT_SEARCH,
    FORM_FIELD_INTERNATIONAL,
    FORM_LABEL_FULLTEXT_SEARCH,
    FORM_LABEL_INTERNATIONAL,
} from '../../../../constants/formConstants';
import {InputCheckBox} from '../../../common/InputCheckbox';
import {moduleRoles} from '../../../../utils/roles';
import {connect} from 'react-redux';
import fulltextSearchMessages from '../../../../intl/afterSales/fulltextSearchMessages';

const StyledDiv = styled.div`
  border-radius: 5px;
`;

const SearchOption = ({roles}) => {
    const isEditor = moduleRoles.isEditorAse(roles);
    const isLvl1SgEditorOnly = moduleRoles.isSGEditorLVL1onlyAse(roles);

    return (
        <>
            <h3 className="text-left mt-4 ml-4">
                <FormattedMessage {...fulltextSearchMessages.SEARCH_OPTION_SECTION}/>
            </h3>
            <StyledDiv className="border border-secondary p-4 bg-white">
                <div className="form-row">
                    <div className="col-xl-4 col-lg-5 col-md-7 pb-2">
                        <InputCheckBox label={fulltextSearchMessages[FORM_LABEL_FULLTEXT_SEARCH]}
                                       field={FORM_FIELD_FULLTEXT_SEARCH}/>
                    </div>
                </div>
                {(isEditor || isLvl1SgEditorOnly) &&
                <div className="form-row">
                    <div className="col-xl-4 col-lg-5 col-md-7 pb-2">
                        <InputCheckBox label={fulltextSearchMessages[FORM_LABEL_INTERNATIONAL]}
                                       field={FORM_FIELD_INTERNATIONAL}/>
                    </div>
                </div>
                }
            </StyledDiv>
        </>
    )
};

const mapStateToProps = state => ({
    roles: state.profile.userDetail.roles,
});

export default connect(mapStateToProps, {})(SearchOption);
